import { StateCreator } from 'zustand';
import { User } from '../../types';

export interface AuthSlice {
  currentUser: User | null;
  isLoading: boolean;
  error: string | null;
  setUser: (user: User | null) => void;
  setLoading: (isLoading: boolean) => void;
  setError: (error: string | null) => void;
  logout: () => void;
  clearAuth: () => void;
  updateUserProfile: (updates: Partial<User>) => void;
}

export const createAuthSlice: StateCreator<AuthSlice> = (set) => ({
  currentUser: null,
  isLoading: true,
  error: null,

  setUser: (user) => {
    if (user) {
      localStorage.setItem('currentUser', JSON.stringify(user));
    } else {
      localStorage.removeItem('currentUser');
    }
    set({ currentUser: user, error: null });
  },

  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  
  logout: () => {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserId');
    localStorage.removeItem('supabase.auth.token');
    set({ currentUser: null, error: null });
  },

  clearAuth: () => {
    // Clear all auth-related state
    localStorage.clear();
    set({
      currentUser: null,
      error: null,
      isLoading: false
    });
  },

  updateUserProfile: (updates) => {
    set((state) => {
      if (!state.currentUser) return state;

      const updatedUser = { ...state.currentUser, ...updates };
      localStorage.setItem('currentUser', JSON.stringify(updatedUser));
      return { currentUser: updatedUser };
    });
  }
});